import { render, staticRenderFns } from "./ModalEnviarEmail.vue?vue&type=template&id=71940bb8&scoped=true&"
import script from "./ModalEnviarEmail.vue?vue&type=script&lang=js&"
export * from "./ModalEnviarEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalEnviarEmail.vue?vue&type=style&index=0&id=71940bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71940bb8",
  null
  
)

export default component.exports